import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setSearchModal } from '../actions/modalActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import Ink from 'react-ink';

class SearchModal extends Component {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        this.props.setSearchModal(false, [], '');
    }

    render() {
        const placeholder = "Zoek een " + this.props.searchmodal.keyword;

        const dummylist = [
            { key: 1, name: "Mark Vedder"},
            { key: 2, name: "Gerco Dekker"},
            { key: 3, name: "Gerben Kroezen"},
            { key: 4, name: "Gerjan Konterman"},
            { key: 5, name: "Laurens Bloemert"},
            { key: 6, name: "Rik Limburg"},
            { key: 7, name: "Henry Roeland"},
            { key: 8, name: "Berno Hoeve"},
            { key: 9, name: "Geert-Jan Bisschop"},
            { key: 10, name: "Marcel Veijer"},
        ]

        return (
            <Modal className='searchModal'
                contentLabel=""
                isOpen={this.props.searchmodal.show}
                style={properties.searchModalStyle}
                >
                <div className="searchModal_header">
                    <div className="header_top">
                        Selecteer {this.props.searchmodal.keyword}
                    </div>
                    <div className="header_bottom">
                        <div className="inputfield">
                            <input type="text" className="searchinput" placeholder={placeholder} />
                        </div>
                        <button className="inputicon">
                            <i className="search icon"> </i>
                            <Ink />
                        </button>
                    </div>
                </div>
                <div className="searchModal_list">
                    <div className="searchModal_scrollable">
                    {
                        dummylist.map(customer => {
                            return (
                                <button className="searchModal_listitem" key={customer.key}>
                                    {customer.name}
                                    <Ink />
                                </button>
                            )
                        })
                    }
                    </div>
                </div>
                <div className="searchModal_footer">
                        <button className="btnCancel" onClick={this.closeModal} >
                            Annuleren
                            <Ink />
                        </button>
                        <button className="btnNext" onClick={this.closeModal}>
                            Volgende
                            <Ink />
                        </button>
                </div>
            </Modal>
        )
    }
}

SearchModal.propTypes = {
}

function mapStateToProps(state) {
    return {
        searchmodal: state.modalState.searchModal
    }
}

export default connect(mapStateToProps, { setSearchModal })(SearchModal)


// WEBPACK FOOTER //
// src/modal/components/SearchModal.jsx